import { Box, Button, Text } from '@chakra-ui/react';
import { Divider } from '@time-line/components/common';
import { env } from 'lib/constants/env';
import NextLink from 'next/link';
import type {
  JunipProductActiveTrait,
  JunipRatingDistribution,
} from 'types/reviews';

import type { ActiveTrait } from './ProductActiveTraits';
import { ProductActiveTraits } from './ProductActiveTraits';
import { ProductRatingDistribution } from './ProductRatingDistribution';
import { ProductReviewStats } from './ProductReviewStats';

export interface ProductReviewsIntroProps {
  showAllProducts?: boolean;
  totalReviews: number;
  averageScore: number;
  ratingDistribution?: JunipRatingDistribution;
  submitReviewUrl?: string;
  recommendedPercentage?: number;
  isMultiProduct?: boolean;
  activeTraits?: JunipProductActiveTrait[];
  ratingFilter?: string;
  setRatingFilter: (rating: string | null) => void;
  overline?: string;
}

export function ProductReviewsIntro({
  showAllProducts,
  totalReviews,
  averageScore,
  submitReviewUrl,
  ratingDistribution,
  recommendedPercentage,
  isMultiProduct,
  activeTraits,
  ratingFilter,
  setRatingFilter,
  overline,
}: ProductReviewsIntroProps) {
  const activeTraitsFiltered = activeTraits?.filter(
    (trait): trait is ActiveTrait => !!trait.ratingAverage,
  );

  return (
    <>
      {overline && !showAllProducts && (
        <Text as="h2" size="overline" mb="sm">
          {overline}
        </Text>
      )}
      <ProductReviewStats
        totalReviews={totalReviews}
        recommendedPercentage={recommendedPercentage}
        averageScore={averageScore}
        isMultiProduct={isMultiProduct}
      />
      {ratingDistribution && (
        <ProductRatingDistribution
          ratingDistribution={ratingDistribution}
          totalReviews={totalReviews}
          ratingFilter={ratingFilter}
          setRatingFilter={setRatingFilter}
        />
      )}
      {activeTraitsFiltered && env.NEXT_PUBLIC_REVIEWS_TRAITS_ENABLED && (
        <Box>
          <Divider width="100%" mt="sm" pt="sm" />
          <ProductActiveTraits traits={activeTraitsFiltered} />
        </Box>
      )}
      {!showAllProducts && submitReviewUrl && (
        <Button
          mt="2xs"
          display="block"
          as={NextLink}
          variant="link"
          target="_blank"
          rel="noopener noreferrer"
          href={submitReviewUrl}
        >
          Write a review
        </Button>
      )}
    </>
  );
}
